import { render, staticRenderFns } from "./ProfileData.vue?vue&type=template&id=0b26aad5&scoped=true&"
import script from "./ProfileData.vue?vue&type=script&lang=js&"
export * from "./ProfileData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b26aad5",
  null
  
)

export default component.exports